import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { FormModule } from '@shared/components/form/form.module';

import { DetailsCommonsModule } from '@shared/modules/details-commons/details-commons.module';
import { GeneralCommonsModule } from '@shared/modules/general-commons/general-commons.module';

import { SearchModule } from '../search/search.module';
import { PractitionerCreateNoteModalComponent } from './components/modals/practitioner-create-note-modal/practitioner-create-note-modal.component';
import { PractitionerDetailsPageComponent } from './components/practitioner-details-page/practitioner-details-page.component';
import { PractitionerSearchPageComponent } from './components/practitioner-search-page/practitioner-search-page.component';
import { PractitionerSearchComponent } from './components/practitioner-search/practitioner-search.component';
import { OverrideQaStageModalComponent } from './components/qa-results/override-qa-stage-modal/override-qa-stage-modal.component';
import { QaResultsPageComponent } from './components/qa-results/qa-results-page.component';
import { PractitionerRoutingModule } from './practitioner-routing.module';

@NgModule({
  imports: [
    CommonModule,
    DetailsCommonsModule,
    FormModule,
    GeneralCommonsModule,
    PractitionerRoutingModule,
    ReactiveFormsModule,
    SearchModule,
    TranslateModule.forChild(),
    OverrideQaStageModalComponent,
    PractitionerDetailsPageComponent,
    PractitionerCreateNoteModalComponent,
    PractitionerSearchPageComponent,
    PractitionerSearchComponent,
    QaResultsPageComponent
  ]
})
export class PractitionerModule {}
